// extracted by mini-css-extract-plugin
export var active = "_kv-e";
export var blink = "_kv-f";
export var dropDownSelector = "_kv-5";
export var dropDownWrapper = "_kv-4";
export var fakeCursor = "_kv-d";
export var fontSizeButton = "_kv-7";
export var formQuillEditor = "_kv-0";
export var pressed = "_kv-g";
export var qlBlank = "_kv-1";
export var textFormattingToolbar = "_kv-2";
export var textFormattingToolbarClosed = "_kv-3";
export var textFormattingToolbarInline = "_kv-6";
export var textToolbarOption = "_kv-8";
export var toolbarCell = "_kv-a";
export var toolbarCellCollapsed = "_kv-b";
export var toolbarOptionHitArea = "_kv-c";
export var toolbarOverflow = "_kv-9";